<div class="filter">
  <div *ngIf="filterStatuses" class="filter__item">
    <app-filter-select [filterTitle]="'statuses'" [filter]="filterStatuses">
    </app-filter-select>
  </div>
  <div *ngIf="filterPaylinkTypes" class="filter__item">
    <app-filter-select
      [filterTitle]="'paylinkTypes'"
      [filter]="filterPaylinkTypes"
    >
    </app-filter-select>
  </div>
  <div *ngIf="filterSinglePayments" class="filter__item">
    <app-filter-select
      [filterTitle]="'singlePayments'"
      [filter]="filterSinglePayments"
    >
    </app-filter-select>
  </div>
  <div class="filter__item">
    <app-amount-range
      [filterSumFrom]="filterSumFrom"
      [filterSumTo]="filterSumTo"
      title="{{ 'FILTERS.SUM' | translate }}"
    >
    </app-amount-range>
  </div>
  <div *ngIf="filterCurrencies" class="filter__item">
    <app-filter-select [filterTitle]="'currencies'" [filter]="filterCurrencies">
    </app-filter-select>
  </div>
  <div class="filter__item">
    <app-period
      [filterStart]="filterStart"
      [filterEnd]="filterEnd"
      title="{{ 'FILTERS.PERIOD_LINKS' | translate }}"
    >
    </app-period>
  </div>
</div>
